import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './i18n';
import './index.scss';
import './polyfills';
import reportWebVitals from './reportWebVitals';
import store from './store/index';

const ensureDocumentStructure = (): void => {
  if (typeof document === 'undefined') {
    return;
  }

  const docEl = document.documentElement;
  if (!docEl) {
    return;
  }

  if (!document.head) {
    const head = document.createElement('head');
    docEl.insertBefore(head, document.body || null);
  }

  if (!document.body) {
    const body = document.createElement('body');
    docEl.appendChild(body);
  }
};

ensureDocumentStructure();

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <BrowserRouter>
    <Provider store={store}>
      <App />
    </Provider>
  </BrowserRouter>
);

reportWebVitals();
